$(document).ready(function() {
'use strict';

$('.order--container').on('click', function () {
  if ($(this).hasClass('follow__link') == false) {
    var orderId = $(this).attr('order-id');
    $('.order__details[order-id="' + orderId + '"]').slideToggle(200).toggleClass('is-active');
    $(this).toggleClass('child-active');
    $(this).children('.open__line__items--link').children().toggleClass('arrow--top arrow--bottom');
  }
});

$('#reset-password').click(function () {
  $('#connexion').css('display', 'none');
  $('#reset').fadeIn("slow");
});

var urlDiag = window.backend.url;
var email = window.general.customerEmail;

var getCookie = function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1, c.length);
    }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

var setCookie = function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

//var email = 'manon.pontillo@gmail.com'
if (window.location.pathname == "/account") {
  if (getCookie('diagnostic-fait')) {
    console.log('on a un cookie');
    $('.faire-diagnostic').hide();
    $('.link-diagnostic-fait').attr('href', '/pages/diagnostic-resultats?email=' + email);
  } else {
    console.log('on n\'a pas de cookie');
    $.ajax({
      type: "GET",
      url: urlDiag + 'diagnostic-beaute?email=' + email,
      crossDomain: true,
      success: function success(diag) {
        console.log(diag);
        $('.faire-diagnostic').hide();
        $('.link-diagnostic-fait').attr('href', '/pages/diagnostic-resultats?email=' + email);
        setCookie("diagnostic-fait", true, 360);
      },
      error: function error(_error) {
        $('.link-diagnostic-fait').hide();
      }
    });
  }
}
'use strict';

$('#accordion-navigation .plus__icon').show();
$('#accordion-navigation').find('li.extend').click(function (e) {
  $(this).children('.extended-submenu').slideToggle('fast');
  $(this).children('.nav--title').children('.plus__icon').toggleClass('opened');
  $(this).toggleClass('active');
});

jQuery.getJSON(window.Shopify.routes.root + 'blogs/conseils-sante/quels-sont-les-bienfaits-de-la-seve-de-bouleau.js', function (product) {
  console.log(product);
  console.log('Nico passe');
});
"use strict";

$(".button--cookie").click(function () {
  $("#cookie--banner").hide();
});

function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}
if (getCookie('cookies-accepted') == 'yes') {} else {
  setTimeout(function () {
    $("#cookie--banner").addClass("apparition--cookie");
    var CookieDate = new Date();
    CookieDate.setMonth(CookieDate.getMonth() + 12);
    document.cookie = "cookies-accepted=yes; expires=" + CookieDate.toGMTString() + "; path=/";
  }, 3000);
}
'use strict';

document.addEventListener('cart:open', function (elem) {
  if (window.cartDrawer.cartType == 'preview') {
    $('#cart__preview').addClass('opened--added-to-cart');
    $('.link--text-style--cart').addClass('link__active');

    if (window.matchMedia("(max-width: 1100px)").matches) {
      //$('#page__overlay--navigation').addClass('opened');
    } else {
      setTimeout(function () {
        $('#cart__preview').removeClass('opened--added-to-cart');
        if ($('#cart__preview').hasClass('opened') == false) {
          $('.link--text-style--cart').removeClass('link__active');
        }
      }, 4000);
    }
  } else {
    $("#cart__drawer").addClass('opened');
    $('#page__overlay').addClass('opened');
    $('#page__overlay').attr('for', 'drawer');
    if (window.matchMedia("(min-width: 1001px)").matches) {
      setTimeout(function () {
        $('#drawer__cart--exta-infos').addClass('opened');
      }, 350);
    }
  }
}, false);

/*var updateDeliveryModule = function(total) {
  if (window.cart.deliveryModule) {
    var deliveryLimit = window.cart.freeDelivery - 1;
    var remainPercentage = Math.max(0 , (deliveryLimit - total) / deliveryLimit * 100);
    var remainMoney = Math.max(0 , (deliveryLimit + 1 - total) / 100);
    var colorBar = 100 - remainPercentage;

    $('#progress__bar--remain').css('width', colorBar + '%')

    if (remainMoney > 0) {
      $('#free__shipping--message').hide();
      $('#remain__shipping__amount--message').show();
      $('.amount__remaining').text(remainMoney + "€");
    } else {
      $('#free__shipping--message').show();
      $('#remain__shipping__amount--message').hide();
    }
  }
}*/
'use strict';

if (window.matchMedia("(min-width: 1101px)").matches) {
  $('.button__action--cart-preview').mouseenter(function (e) {
    $('#cart__preview').addClass('opened');
    //handleNavbarHover("opened");
  });

  $('#cart__preview').mouseenter(function (e) {
    $('#cart__preview').addClass('opened');
    //handleNavbarHover("opened");
  });

  $('#cart__preview').mouseleave(function (e) {
    $('#cart__preview').removeClass('opened');
    $('#cart__preview').removeClass('opened--added-to-cart');

    $('.link--text-style--cart').removeClass('link__active');
    /*if ($(e.relatedTarget).is('.link--text-style')) {
    } else {
      handleNavbarHover("closed");
    }*/
  });

  $('.button__action--cart-preview').mouseleave(function (e) {
    $('#cart__preview').removeClass('opened');
    $('#cart__preview').removeClass('opened--added-to-cart');

    $('.link--text-style--cart').removeClass('link__active');
    /*if ($(e.relatedTarget).is('.links__container--half, #navigation__links--list, .link--text-style, .announcement__bar--container')) {
    } else {
      handleNavbarHover("closed");
    }*/
  });
} else {
  $('.button__action--cart-preview').on('click', function () {
    if ($('#cart__preview').hasClass('opened')) {
      $('#cart__preview').removeClass('opened');
      $('#cart__preview').removeClass('opened--added-to-cart');
      $('#page__overlay--navigation').removeClass('opened');
      //handleNavbarHover("closed");
    } else {
      $('#cart__preview').addClass('opened');
      $('#page__overlay--navigation').addClass('opened');
      //handleNavbarHover("opened");
    }
  });

  $('.close--cart-preview').on('click', function () {
    $('#cart__preview').removeClass('opened opened--added-to-cart');
    $('#cart__preview').removeClass('opened--added-to-cart');
    $('#page__overlay--navigation').removeClass('opened');
    //handleNavbarHover("closed");
  });

  $('#page__overlay--navigation').on('click', function () {
    $('#cart__preview').removeClass('opened opened--added-to-cart');
    $('#cart__preview').removeClass('opened--added-to-cart');
    $('#page__overlay--navigation').removeClass('opened');
    //handleNavbarHover("closed");
  });
}

if ($(document).scrollTop() > 20) {
  $("#cart__preview").css('top', '48px');
}

$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    $("#cart__preview").css('top', '48px');
  } else {
    $("#cart__preview").css('top', '85px');
  }
});

function handleNavbarHover(status) {
  if (window.location.pathname == "/") {
    if (window.matchMedia("(min-width: 1101px)").matches) {
      if (status == "opened") {
        $('.link--text-style--cart').addClass('link__active');
        $('#navigation--container').removeClass('transparent--nav');
        $('#main__logo--svg').removeClass('logo--white');
      } else {
        $('#navigation--container').addClass('transparent--nav');
        $('#main__logo--svg').addClass('logo--white');
      }
    }
  }
}
'use strict';

// Add to cart funnction
if (window.location.pathname == "/cart") {
  window.cartDrawer.drawer = false;
}

function addGiftToCart(qty) {
  if (window.general.giftEnabled) {
    var variantQty = 1;
    if (qty == 0) {
      variantQty = 0;
    }
    var variantId = 49321570763097;
    var objUpdate = { updates: {} };
    console.log("herer gift Add")
    objUpdate.updates[variantId] = variantQty;
    setTimeout(() => {
      $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: objUpdate,
      dataType: 'json',
      success: function success(response) {
        renderCart();
        updateCartData(false);
      },
      error: function error(_error) {
        console.log('erreur');
        console.log(_error);
      }
    });},1500);
  }
}

$('body').on('click', '.add__to__cart--grid-item', function (e) {
  e.preventDefault();
  var $this = $(this);
  var variant_id = $this.attr('product-variant');
  var variantPrice = $(this).attr('variant-price');
  var productId = $(this).attr('product-id');
  var productType = $(this).attr('product-type');
  var productTitle = $(this).attr('product-title');

  var qty = 1;
  var objUpdate = { quantity: qty, id: variant_id };
  setTimeout(() => {
    $.ajax({
    type: "POST",
    url: '/cart/add.js',
    data: objUpdate,
    dataType: "json",
    success: function success(response) {
      //document.dispatchEvent(new CustomEvent('addToCart--render'));
      renderCart();
      updateCartData(true);
      addGiftToCart();

      /* if ($(this).hasClass('reco-product')){
         gtag('event', 'add_to_cart_reco', {
           'product': productTitle
         });
       }
       gtag('event', 'add_to_cart', {
         'product': productTitle
       });*/

      document.dispatchEvent(new CustomEvent('update-reco-drawer'));
      //document.dispatchEvent(new CustomEvent('product:added'));
      if (window.location.href.indexOf("collections") > -1 || window.location.href.indexOf("/") > -1) {
        document.dispatchEvent(new CustomEvent('cart:open'));
      }

      if (window.dataLayer) {
        window.dataLayer.push({
          "event": "ecommerce",
          "eventCategory": "ecommerce",
          "eventAction": "addtocart",
          "eventLabel": "success",
          "productName": productTitle || "",
          "productCategory": productType || "",
          "productID": productId || "",
          "variantID": variant_id || "",
          "productPrice": parseFloat(variantPrice),
          "quantity": 1,
          "totalPrice": parseFloat(variantPrice)
        });
      }

      if ($('#empty__cart--title').length > 0) {
        location.reload(true);
      }
      setTimeout(function () {
        $this.children('.button--loading').css('display', 'none');
        $this.children('.button--text').show();
      }, 300);

      if (window.matchMedia("(max-width: 1000px)").matches) {
        setTimeout(function () {
          $('#drawer__cart--exta-infos').removeClass('opened');
        }, 500);
      }
    },
    error: function error(_error2) {
      console.log('erreur');
    }
  });},1500);
});

$('body').on('click', '.add__to__cart', function (e) {
  e.preventDefault();
  var variantId = $(this).attr('variant-id');
  var variantPrice = $(this).attr('variant-price');
  var productId = $(this).attr('product-id');
  var available = $(this).attr('variant-available');
  var productHandle = $(this).attr('product-handle');
  var productType = $(this).attr('product-type');
  var productTitle = $(this).attr('product-title');
  var variants = $(this).attr('variants');
  var type = $(this).attr('button-type');
  var $this = $(this);

  $this.children('.button--text').css('display', 'none');
  $this.children('.button--loading').css('display', 'block');

  if (available == 'true' || available == true) {
    if (variantId) {
      var qty = 1;
      if (type == 'product') {
        qty = $('.product__qty--container .quantity__current').val();
      }
      var objUpdate = { quantity: qty, id: variantId };
      setTimeout(() => {
        $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: objUpdate,
        dataType: 'json',
        success: function success(response) {
          renderCart();
          updateCartData(true);
          addGiftToCart();
          document.dispatchEvent(new CustomEvent('update-reco-drawer'));

          if ($('#empty__cart--title').length > 0) {
            location.reload(true);
          }

          /*if ($(this).hasClass('collection-product')){
            gtag('event', 'add_to_cart_collection', {
              'product': productTitle
            });
          } else if ($(this).hasClass('product-product')){
            gtag('event', 'add_to_cart_product', {
              'product': productTitle
            });
          }
           gtag('event', 'add_to_cart', {
            'product': productTitle
          });*/

          if (window.dataLayer) {
            var totalTransaction = parseFloat(variantPrice) * parseFloat(qty);
            totalTransaction = totalTransaction.toFixed(2);
            window.dataLayer.push({
              "event": "ecommerce",
              "eventCategory": "ecommerce",
              "eventAction": "addtocart",
              "eventLabel": "success",
              "productName": productTitle || "",
              "productCategory": productType || "",
              "productID": productId || "",
              "variantID": variantId || "",
              "productPrice": parseFloat(variantPrice),
              "quantity": parseInt(qty),
              "totalPrice": parseFloat(totalTransaction)
            });
          }

          document.dispatchEvent(new CustomEvent('cart:open'));
          $this.children('.button--text').css('display', 'block');
          $this.children('.button--loading').css('display', 'none');
        },
        error: function error(_error3) {
          console.log(_error3);
        }
      });},1500);
    }
  }
});

$('body').on('change', '.qty--input', function (e) {
  e.preventDefault();
  var $this = $(this);
  var variantId = $(this).attr('variant-id');
  var variantQty = $this.val();

  if (variantId) {
    var data = { updates: {} };
    data.updates[variantId] = variantQty;

    setTimeout(() => {
      $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function success(response) {
        // On render le cart via le module shippinh-module-cart.js
        updateCartData(false);
      },
      error: function error(_error4) {
        console.log('erreur');
      }
    });},1500);
  }
});

$('body').on('click', '.remove--line-item', function (e) {
  e.preventDefault();
  var $this = $(this);
  var key = $(this).attr('key');
  var title = $(this).attr('title');
  var data = { updates: {} };
  data.updates[key] = 0;
  setTimeout(function () {
    $('.cart__item--container[key="' + key + '"]').remove();
  }, 300);
  setTimeout(() => {
    $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function success(response) {
      /*gtag('event', 'remove', {
        'label': title
      });*/
      updateCartData(false);
      renderCart();
      document.dispatchEvent(new CustomEvent('update-reco-drawer'));
      if (response.item_count == 1) {
        addGiftToCart(0);
      }
    },
    error: function error(_error5) {
      console.log('erreur');
    }
  });},1500);
});

var renderCart = function renderCart() {
  var url = '/cart?view=sidecart&timestamp=' + Date.now();

  if (window.general.langue !== "fr") {
    url = '/' + window.general.langue + '/cart?view=sidecart&timestamp=' + Date.now();
  }

  if (window.location.pathname.indexOf('cart') > -1) {
    url = '/cart?view=page&timestamp=' + Date.now();
  }

  $.ajax({
    type: 'GET',
    url: url,
    success: function success(content) {
      var newCart = content;
      $('.cart__items__and__header--container').remove();
      $('.cart--body').append(newCart);
    },
    error: function error(_error6) {
      console.log(_error6);
    }
  });
};

if (window.cart && window.cartDrawer.drawer == true) {
  renderCart();
}

function klaviyoCart(response) {
  console.log(response);
  var _learnq = window._learnq || [];
  var cart = {
    total_price: response.total_price / 100,
    $value: response.total_price / 100,
    total_discount: response.total_discount,
    original_total_price: response.original_total_price / 100,
    items: response.items
  };
  console.log(cart);
  _learnq.push(['track', 'Added to Cart', cart]);
}

var updateCartData = function updateCartData(add) {
  var url = "/cart";
  if (window.general.langue !== "fr") {
    url = '/' + window.general.langue + '/cart';
  }
  $.ajax({
    type: 'GET',
    url: url,
    dataType: 'json',
    success: function success(response) {
      var total = response.total_price;
      var empty = response.item_count == 0 ? true : false;
      updateDeliveryModule(total);
      if (add == true) {
        klaviyoCart(response);
      }

      if (empty) {

        $('.cart--body').addClass('empty__cart');
        $('.cart__total--drawer, .vertical--separator').addClass('display__none');
        $('.empty__cart--drawer').removeClass('display__none');

        $('.items--count').text(0);

        if ($('#full__cart--title').length > 0) {
          location.reload(true);
        }
      } else {

        $('.cart--body').removeClass('empty__cart');
        $('.empty__cart--drawer').addClass('display__none');
        $('.cart__total--drawer, .vertical--separator').removeClass('display__none');
        $('.cart__total--drawer').text(displayPrice(total));

        $('.items--count').text(response.item_count);

        $('.cart__item--total-price').text(displayPrice(total));
        response.items.forEach(function (line_item) {
          var variantId = line_item.variant_id;
          $('.cart__item--container[variant-id=' + variantId + '] .cart__item--total-price').text(displayPrice(line_item.line_price));
        });
      }
    },
    error: function error(_error7) {
      console.log('erreur');
    }
  });
};

$('#checkout--button').on('click', function (e) {
  e.preventDefault();
  document.location.href = "/checkout";
  /*gtag('event', 'debut_checkout', {
    'label': 'Commencer'
  });*/
});

$(window).on('load', function () {
  renderCart();
  updateCartData();
});
"use strict";

if (window.cartDrawer) {
    var deliveryModuleWidth = 100;
    var renderFirst = 0;

    var nbSteps = window.cartDrawer.nbSteps;
    if (nbSteps > 1 && nbSteps < 3) {
        deliveryModuleWidth = 33.33;
    } else if (nbSteps > 3) {
        deliveryModuleWidth = 20;
    } else if (nbSteps > 2) {
        deliveryModuleWidth = 25;
    }
    var ajaxCartProducts = function ajaxCartProducts(qty1, qty2, qty3, delay = 1500) {
        var objUpdate = { updates: {} };
        objUpdate.updates[window.cartDrawer.product1] = qty1;
        objUpdate.updates[window.cartDrawer.product2] = qty2;
        objUpdate.updates[window.cartDrawer.product3] = qty3;
     
        setTimeout(() => {
          $.ajax({
                type: "POST",
                url: '/cart/update.js',
                data: objUpdate,
                dataType: "json",
                success: function success(response) {
                    if (response.item_count == 0) {
                        $('.cartDrawer--body').addClass('empty__cart');
                    }
                    renderCart();
                },
                error: function error(_error) {
                    console.log(_error);
                }
            });
        },delay);
    };

    var shippingBarLogic = function shippingBarLogic(total) {
        var currentStep = 1;
        var prefix = "";
        var message = "";
        var suffix = "";

        if (total >= window.cartDrawer.steps[0] && total < window.cartDrawer.steps[1]) {
            currentStep = 2;
        } else if (total >= window.cartDrawer.steps[1] && total < window.cartDrawer.steps[2]) {
            currentStep = 3;
        } else if (total >= window.cartDrawer.steps[2] && total < window.cartDrawer.steps[3]) {
            currentStep = 4;
        } else if (total >= window.cartDrawer.steps[3]) {
            currentStep = 5;
        }

        if (currentStep == 1) {
            prefix = window.cartDrawer.stepsPrefix[0];
            message = window.cartDrawer.stepsMessages[0];
            suffix = window.cartDrawer.stepsSuffix[0];
        } else if (currentStep == 2) {
            prefix = window.cartDrawer.stepsPrefix[1];
            message = window.cartDrawer.stepsMessages[1];
            suffix = window.cartDrawer.stepsSuffix[1];
        } else if (currentStep == 3) {
            prefix = window.cartDrawer.stepsPrefix[2];
            message = window.cartDrawer.stepsMessages[2];
            suffix = window.cartDrawer.stepsSuffix[2];
        } else {
            prefix = window.cartDrawer.stepsPrefix[3];
            message = window.cartDrawer.stepsMessages[3];
            suffix = window.cartDrawer.stepsSuffix[3];
        }

        var remainMoney = 0;
        var remainPercentage = 0;
        var colorBar = 0;

        var barCalculus = function barCalculus(step, total) {
            var seuilSuivant = window.cartDrawer.steps[step - 1];
            var seuilPrecedent = 0;
            if (step != 1) {
                seuilPrecedent = window.cartDrawer.steps[step - 2];
            }
            remainMoney = Math.max(0, (seuilSuivant - total) / 100);
            remainPercentage = Math.max(0, (seuilSuivant - total) / (seuilSuivant - seuilPrecedent));
            colorBar = deliveryModuleWidth * step - deliveryModuleWidth * remainPercentage;
        };

        var finalStep = function finalStep() {
            remainMoney = 0;
            remainPercentage = 0;
            colorBar = 100;
        };

        switch (currentStep) {
            case 1:
                barCalculus(1, total);
                break;
            case 2:
                barCalculus(2, total);
                break;
            case 3:
                barCalculus(3, total);
                break;
            case 4:
                barCalculus(4, total);
                break;
            case 5:
                barCalculus(5, total);
                break;
            default:
                break;
        }

        console.log(currentStep);
        console.log('Nicolas');

        if (currentStep == 1) {
            ajaxCartProducts(0, 0, 0,1500);
        } else if (currentStep == 2 && nbSteps > 1) {
            ajaxCartProducts(0, 0, 0,1500);
        } else if (currentStep == 3) {
            ajaxCartProducts(1, 0, 0,1500);
            if (nbSteps == 2) {
                finalStep();
            }
        } else if (currentStep == 4) {
            if (window.cartDrawer.seuil3State) {
                ajaxCartProducts(1, 1, 0,1500);
            } else {
                ajaxCartProducts(1, 0, 0,1500);
            }
            if (nbSteps == 3) {
                finalStep();
            }
        } else if (currentStep == 5) {
            if (window.cartDrawer.seuil4State) {
                ajaxCartProducts(1, 1, 1,1500);
            } else if (window.cartDrawer.seuil3State) {
                ajaxCartProducts(1, 1, 0,1500);
            } else {
                ajaxCartProducts(1, 0, 0,1500);
            }
            finalStep();
        }

        $('#progress__bar--remain').css('width', colorBar + '%');

        if (remainMoney > 0) {
            var moinsDix = remainMoney < 10 ? true : false;
            remainMoney = remainMoney.toString().replace('.', ',');
            if (moinsDix == true && remainMoney.length == 3) {
                remainMoney = remainMoney + '0';
            } else if (moinsDix == false && remainMoney.length == 4) {
                remainMoney = remainMoney + '0';
            }
            $('#bar__success--message').hide();
            $('#bar__remain--message').show();
            $('#amount__remaining').text(remainMoney + "€");
            $('#prefix--message').text(prefix);
            $('#next__gift--message').text(message);
            $('#suffix--message').text(suffix);
        } else {
            $('#bar__success--message').show();
            $('#bar__remain--message').hide();
        }
    };

    var getCartTotal = function getCartTotal(callback, cart) {
        if (cart) {
            if (callback) {
                callback(cart.total_price);
            } else {
                return cart.total_price;
            }
        } else {
            setTimeout(() => {
              $.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function success(cart) {
                    if (callback) {
                        callback(cart.total_price);
                    } else {
                        return cart.total_price;
                    }
                }
            });
            },1500);
        }
    };

    var initializeDeliveryModule = function initializeDeliveryModule() {
        var total = getCartTotal(shippingBarLogic);
    };

    if (window.cartDrawer.emptyCart == false) {
        setTimeout(function () {
            initializeDeliveryModule();
        }, 1000);
    }

    var updateDeliveryModule = function updateDeliveryModule(total) {
        if (window.cartDrawer.deliveryModule) {
            if (total) {
                shippingBarLogic(total);
            } else {
                getCartTotal(shippingBarLogic);
            }
        }
    };
}
"use strict";

var emballageCadeauVariantId = window.giftBoxvariant;
$(".emballage__cadeau--button").on("click", function () {
  var data = { updates: {} };
  data.updates[emballageCadeauVariantId] = 1;
  var url = "/cart/update.js";
  if (window.general.langue !== "fr") {
    url = "/" + window.general.langue + "/cart/update.js";
  }
  setTimeout(() => {
  $.ajax({
    type: 'POST',
    url: url,
    data: data,
    dataType: 'json',
    success: function success() {
      location.reload();
    }
  });
  },1500);
  
});
'use strict';

document.addEventListener('update-reco-drawer', function (e) {
  var url = 'https://' + window.location.hostname + '/?section_id=reco-lateral';
  if (window.general.langue !== "fr") {
    url = 'https://' + window.location.hostname + '/' + window.general.langue + '/?section_id=reco-lateral';
  }
  setTimeout(() => {
    $.ajax({
    type: 'GET',
    url: url,
    success: function success(data) {
      $('#product-reco--container').empty().append(data);
    },
    error: function error(_error) {
      console.log('erreur');
      console.log(_error);
    }
  });},1500);
}, false);

$('body').on('click', '.reco--aded-to-cart', function (e) {
  var handle = $(this).attr('product-handle');
  if (typeof ga === "function") {
    ga('send', 'event', 'Produit recommandé', 'Ajout au panier', handle);
  }
});

// document.dispatchEvent(new CustomEvent('update-reco-drawer')); --> a ajouter lors des ajouts au panier
'use strict';

if (window.collection) {
  var selectedInput = $('.select__custom--value[value="' + window.collection.defaultSortBy + '"]').first().text();

  $('.select__custom--value[value="' + window.collection.defaultSortBy + '"]').addClass('is__active');

  if (window.matchMedia("(min-width: 768px)").matches) {
    $('.select__custom--selected-value').text(selectedInput);
  }
}
'use strict';

// Filters
$('.filter__group--title').on('click', function () {
  // Fermture des autres filtres
  if (window.matchMedia("(min-width: 768px)").matches) {
    $('.filter__group--item-list').slideUp(300);
  }
  $('.icon--arrow-bottom').removeClass('opened');
  if ($(this).hasClass('opened')) {
    $(this).removeClass('opened');
    $(this).children('.filter__section--title').children('.icon--arrow-bottom').removeClass('opened');

    if (window.matchMedia("(max-width: 767px)").matches) {
      $(this).siblings('.filter__group--item-list').slideUp(300);
    }
  } else {
    $(this).children('.filter__section--title').children('.icon--arrow-bottom').toggleClass('opened');
    $(this).siblings('.filter__group--item-list').slideToggle(300);
    $('.filter__group--title').removeClass('opened');
    $(this).toggleClass('opened');
  }
});

// Filters
$('body').on('click', '.reinitialize__filters', function () {
  window.collection.currentFilters = [];
  $('.reinitialize__filters').hide();
  $('.filter__item--mini').remove();
  $('.filter__button').removeClass('is__active');
  var filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '?sort_by=' + window.collection.sortBy;
  if (history.replaceState) {
    window.history.replaceState({ path: filteredUrl }, '', filteredUrl);
  }
  $.ajax({
    type: 'GET',
    url: filteredUrl + '&view=filtered',
    success: function success(content) {
      var count = parseInt(content.substring(0, 4));
      $('.filter-count').text(count);
      $('#collection__list--container').remove();
      $('#collection__page--desktop').append(content.substring(4));
      $('.close[for=drawer-filter]').click();
    },
    error: function error(_error) {
      console.log('erreur');
    }
  });
});

$('body').on('click', '.filter__item--mini', function () {
  var filter_value = $(this).attr('filter-value-handle');
  $('.filter__item--mini[filter-value-handle=' + filter_value + ']').remove();
  $('.filter__button[filter-value-handle=' + filter_value + ']')[0].click();
});

$('body').on('click', '.filter__button', function () {
  var mini__filter = window.collection.miniFilter;
  var filter_value = $(this).attr('filter-value-handle'),
      filteredUrl = '';
  var filtersList = window.collection.currentFilters;

  // Gestion de laccordeon
  if (window.matchMedia("(min-width: 768px)").matches) {
    $('.filter__group--item-list').slideUp(300);
    $('.icon--arrow-bottom').removeClass('opened');
  }
  $('.filter__group--title').removeClass('opened');

  if ($(this).hasClass('is__active')) {
    $('.filter__button[filter-value-handle=' + filter_value + ']').removeClass('is__active');

    filtersList.splice(filtersList.indexOf(filter_value), 1);

    window.collection.currentFilters = filtersList;
    window.collection.currentFilters.sort();

    $('.filter__item--mini[filter-value-handle=' + filter_value + ']').remove();
  } else {
    // Supprime les tags du meme groupe deja actifs
    var group = filter_value.split('_')[0];
    $('.filter__button[filter-group-handle="' + group + '"]').removeClass('is__active');
    $('.filter__item--mini[filter-group-handle="' + group + '"]').remove();
    $('.filter__button[filter-value-handle=' + filter_value + ']').addClass('is__active');
    for (var i = 0; i < filtersList.length; i++) {
      if (filtersList[i].indexOf(group) > -1) {
        filtersList.splice(i, 1);
      }
    }

    window.collection.currentFilters = filtersList;
    window.collection.currentFilters.push(filter_value);
    window.collection.currentFilters.sort();

    $('.filter__values--list').append('<li class="filter__item--mini text--nav white text__uppercase" filter-value-handle="' + filter_value + '" filter-group-handle="' + group + '"><span>' + $(this).attr('filter-value') + '</span><span class="close close__filter close__filter__device"></span></li>');
  }

  if (window.collection.currentFilters.length > 0) {
    $('.reinitialize__filters').show();
    filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '/' + window.collection.currentFilters.join('+') + '?sort_by=' + window.collection.sortBy;
  } else {
    $('.reinitialize__filters').hide();
    filteredUrl = window.location.protocol + '//' + window.location.host + window.collection.collectionUrl + '?sort_by=' + window.collection.sortBy;
  }

  if (history.replaceState) {
    window.history.replaceState({ path: filteredUrl }, '', filteredUrl);
  }

  $.ajax({
    type: 'GET',
    url: filteredUrl + '&view=filtered',
    success: function success(content) {
      var count = parseInt(content.substring(0, 4));
      $('.filter-count').text(count);
      $('#collection__list--container').remove();
      $('#collection__page--desktop').append(content.substring(4));
    },
    error: function error(_error2) {
      console.log('erreur');
    }
  });
});

// mobile
$('.action--button-validate').on('click', function (e) {
  e.preventDefault();
  $('#navigation__drawer--header .close').click();
});
$('.action--button-close').on('click', function (e) {
  e.preventDefault();
  $('#navigation__drawer--header .close').click();
});
/*$('.product__item__link--container').on('click', function(e) {
  e.preventDefault();
  if ($(e.target).is('.property--item')) {
    var url = $(e.target).attr('link');
    window.location.href = url;
  } else {
    window.location = this.href;
  }
})*/
"use strict";
'use strict';

// faq2.liquid
$('.title-link__container').on('click', function () {
  var number = $(this).attr('data-separator');
  $('.title-link__container').removeClass('is-active');
  $(this).addClass('is-active');
  $('.questions__container.is-opened').removeClass('is-opened is-visible');
  $('.questions__container[data-separator=' + number + ']').addClass('is-opened');
  setTimeout(function () {
    $('.questions__container[data-separator=' + number + ']').addClass('is-visible');
  }, 10);
});
'use strict';

// Ouvrir la modal au clic
$('.button__action').on('click', function (e) {
  e.preventDefault();
  var buttonFor = $(this).attr('for');
  var selector = $(this).attr('open-selector');
  if (selector) {
    $(selector).addClass('opened');
    $('#page__overlay').addClass('opened');
  }

  if (buttonFor == 'modal' && selector) {
    $('#page__overlay').attr('for', 'modal');
  } else if (buttonFor == 'drawer' && selector) {
    $('#page__overlay').attr('for', 'drawer');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'hidden' });
    }
  } else if (buttonFor == 'drawer-cart' && selector) {
    $('.cart__item__image, .image-reco').show();
    $('#page__overlay').attr('for', 'drawer');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'hidden' });
    }
    if (window.matchMedia("(min-width: 1001px)").matches) {
      setTimeout(function () {
        $('#drawer__cart--exta-infos').addClass('opened');
      }, 350);
    }
  } else if (buttonFor == 'drawer-filter' && selector) {
    $('#filter__drawer').addClass('opened');
  } else if (buttonFor == 'accordeon') {
    var isActive = false;
    if ($(this).hasClass('active')) {
      isActive = true;
    }
    if ($(this).hasClass('link--item-button')) {
      $('.link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.link--item-button.active').removeClass('active');
    } else if ($(this).hasClass('sub__link--item-button')) {
      $('.sub__link--item-button.active').siblings('.accordeon__list').removeClass('opened').slideToggle('500');
      $('.sub__link--item-button.active').children('.plus__icon').removeClass('opened');
      $('.sub__link--item-button.active').removeClass('active');
    }

    if (isActive == false) {
      $(this).toggleClass('active');
      $(this).children('.plus__icon').toggleClass('opened');
      $(this).siblings('.accordeon__list').addClass('opened').slideToggle('500');
    }
  }
  if (buttonFor == 'select' && selector) {
    $('#page__overlay').attr('for', 'select');
  }
});

// Fermer la modal au clic sur la croix
$('.close, .close--button').on('click', function (e) {
  e.preventDefault();
  var closeFor = $(this).attr('for');

  if (closeFor == 'drawer-shipping' || closeFor == 'drawer-reco') {} else {
    $('#page__overlay').removeClass('opened');
    $('#page__overlay').attr('for', '');
  }

  if (closeFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  } else if (closeFor == 'drawer') {
    $('.drawer').removeClass('opened');
    $('.drawer-shipping').removeClass('opened');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'visible' });
    }
  } else if (closeFor == 'drawer-filter') {
    $('.drawer-filter').removeClass('opened');
    $('.supports-no-cookies').css('overflow', '');
  } else if (closeFor == 'drawer-shipping') {
    $('.drawer-shipping').removeClass('opened');
  } else if (closeFor == 'drawer-reco') {
    $('.drawer-reco').removeClass('opened');
  } else if (closeFor == 'select') {
    $('.select').removeClass('opened');
  }
});

// Clic en dehors de la'modal'
$('#page__overlay').on('click', function (e) {
  e.preventDefault();
  var overlayFor = $(this).attr('for');

  $(this).removeClass('opened');
  $('#page__overlay').attr('for', '');

  if (overlayFor == 'modal') {
    $('.modal').removeClass('opened');
    $('.modal-loader').show();
    $('.modal-has-to-load').hide();
  } else if (overlayFor == 'drawer') {
    $('.drawer').removeClass('opened');
    $('.drawer-shipping').removeClass('opened');
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('html, body').css({ overflow: 'visible' });
    }
  } else if (overlayFor == 'select') {
    $('.select').removeClass('opened');
  }
});

// Ajout de la variant lors de la selection + Fermer modal
$('.variant__select').on('click', function (e) {
  //$('#iddeclasse').attr('variant', $(this).attr("value"));
  e.preventDefault();
  $('.select').removeClass('opened');
  var closeFor = $(this).attr('for');
  $('#page__overlay').removeClass('opened');
  $('#page__overlay').attr('for', '');
});

$('#page__overlay--white').on('click', function (e) {
  e.preventDefault();
  $(this).removeClass('opened');
  $('.select__custom--values').hide();
  $('.select__custom--values').removeClass('opened');
});
"use strict";
'use strict';

// Click sur le select
$('body').on('click', '.select__custom--selected-value-container', function (e) {
  var forSelect = $(this).attr('for');
  $('.select__custom--values[for="' + forSelect + '"]').fadeToggle(50);
  $('.select__custom--values[for="' + forSelect + '"]').addClass('opened');
  $('#page__overlay--white').addClass('opened');
});

$('body').on('click', '.select__custom--value', function (e) {
  var forSelect = $(this).attr('for');
  var value = $(this).attr('value');
  var valueText = $(this).text();
  //est ce quon a modifie un select via quick view
  var quickAdd = $(this).attr('product-grid') || "false";

  $('.select__custom--value[for="' + forSelect + '"]').removeClass('is__active');
  $(this).addClass('is__active');

  $('.select__custom--selected-value[name="' + forSelect + '"]').text(valueText);
  $('.select__hidden[for="' + forSelect + '"]').val(value).trigger('change');
  $('.select__custom--values').hide();
  $('.select__custom--values').removeClass('opened');
  $('#page__overlay--white').removeClass('opened');
  document.dispatchEvent(new CustomEvent('select-changed:' + forSelect, { 'detail': { quickAdd: quickAdd } }));
});

document.addEventListener('select-changed:sort--by', function (elem) {
  console.log('Select has changed');
}, false);

// Sort
Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
$('.select__hidden[for="sort--by"]').bind('change', function () {
  Shopify.queryParams.sort_by = $(this).val();
  location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
});
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var prevArrow = '<svg class="slick-arrow--left" viewBox="0 0 53.4 18.8"><defs><style>.cls-1{fill:#404040;}</style></defs><path class="cls-1" d="M0,9.3V10a.1.1,0,0,0,.1.1v.1h0l.1.1h0l10,8a1,1,0,0,0,1.2-1.6L3.6,10.5H51.9a.94.94,0,0,0,1-1,.94.94,0,0,0-1-1H3.8l7.8-6.2A1.08,1.08,0,0,0,11.8.9,1.23,1.23,0,0,0,11,.5a1.42,1.42,0,0,0-.6.2l-10,8h0l-.1.1h0v.1L.2,9C0,9.2,0,9.2,0,9.3Z"/></svg>';
var nextArrow = '<svg class="slick-arrow--right" x="0px" y="0px"viewBox="0 0 53.4 18.8" style="enable-background:new 0 0 53.4 18.8;" xml:space="preserve"> <style type="text/css"> .st0{fill:#404040;} </style> <path class="st0" d="M52.9,9.7V9.6V9.5c0,0,0,0,0-0.1s0,0,0-0.1V9.2V9.1V9c0,0,0-0.1-0.1-0.1V8.8l0,0l-0.1-0.1l0,0l-10-8 c-0.4-0.3-1.1-0.3-1.4,0.2C41,1.3,41,2,41.5,2.3l7.8,6.2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h48.1l-7.8,6.2c-0.4,0.3-0.5,1-0.2,1.4 c0.2,0.2,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2l10-8l0,0l0.1-0.1l0,0v-0.1l0.1-0.1C52.9,9.8,52.9,9.8,52.9,9.7z"/> </svg>';

var initSlick = function initSlick() {
  var _$$slick;

  $('.background-slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.carousel-product-list').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 950,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  $('.collection-slider-home').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 950,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  $('.product-list-special-slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  $('.blog-slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.slider-gamme').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 2,
    slidesToScroll: 1
  });

  $('.slider-temoignages').slick({
    dots: true,
    customPaging: function customPaging(slider, i) {
      return '<button class="tab"></button>';
    },
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('#instagram-feed').slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 5
      }
    }, {
      breakpoint: 1000,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        autoplay: false
      }
    }]
  });

  $('#bandeau--footer-slider').slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 950,
      settings: {
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 2000
      }
    }]
  });

  $('#promesses-homepage').slick({
    dots: false,
    infinite: true,
    arrows: false,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    variableWidth: true,
    responsive: [{
      breakpoint: 1100,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  $('#homeslider').slick((_$$slick = {
    dots: false,
    infinite: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000
  }, _defineProperty(_$$slick, 'dots', true), _defineProperty(_$$slick, 'customPaging', function customPaging(slider, i) {
    return '<button class="tab"></button>';
  }), _$$slick));

  $('#swiper-container-featured-collection-1').slick({
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  $('#carousel-product-recommande').slick({
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 950,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  if (window.productTags && window.productTags.slider == true) {
    $('#tags-banniere-produit').slick({
      dots: false,
      infinite: true,
      arrows: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 2000,
      centerMode: true,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }]
    });
  } else {
    if (window.matchMedia("(max-width: 768px)").matches) {
      $('#tags-banniere-produit').slick({
        dots: false,
        infinite: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 2000,
        centerMode: true
      });
    }
  }

  $('#slider__blog--articles').slick({
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1000,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  $('#carousel-ingredients').slick({
    dots: false,
    infinite: false,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 950,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  $('.collection-herbier--slick').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 3,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  $('#slider__page--articles').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1000,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  $('#carousel-article-product-recommande').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }]
  });

  $('#review-slider').slick({
    dots: false,
    infinite: true,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 967,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }]
  });
};

$(document).ready(function () {
  initSlick();
});

document.addEventListener('theme-editor--slick', function (e) {
  initSlick();
}, false);
'use strict';

var announcementDetails = {};
if ($('[announcement-details]').html()) {
  announcementDetails = JSON.parse($('[announcement-details]').html());
}

var text_ecran = announcementDetails.text_ecran;
var text_mobile = announcementDetails.text_mobile;
var lien_ecran = announcementDetails.lien_ecran;
var lien_mobile = announcementDetails.lien_mobile;
var counter = 1;
var elem = $("#annonce");

if (window.matchMedia("(min-width: 767px)").matches) {
  var change = function change() {
    if (text_ecran && text_ecran.length > 1) {
      elem.fadeOut(function () {
        elem.html(text_ecran[counter]);
        if (lien_ecran[counter] != "unlink") {
          elem.attr("href", lien_ecran[counter]);
        } else {
          elem.removeAttr('href');
        }
        counter++;
        if (counter >= text_ecran.length) {
          counter = 0;
        }
        elem.fadeIn();
      });
    }
  };

  if (lien_ecran && lien_ecran[0] != "unlink") {
    elem.attr("href", lien_ecran[0]);
  } else {
    elem.removeAttr('href');
  }
  setInterval(change, 6000);
} else {
  var _change = function _change() {
    if (text_mobile && text_mobile.length > 1) {
      elem.fadeOut(function () {
        elem.html(text_mobile[counter]);
        if (lien_mobile[counter] != "unlink") {
          elem.attr("href", lien_mobile[counter]);
        } else {
          elem.removeAttr('href');
        }
        counter++;
        if (counter >= text_mobile.length) {
          counter = 0;
        }
        elem.fadeIn();
      });
    }
  };

  if (lien_ecran && lien_mobile[0] != "unlink") {
    elem.attr("href", lien_mobile[0]);
  } else {
    elem.removeAttr('href');
  }

  text_mobile ? elem.html(text_mobile[0]) : null;
  setInterval(_change, 3000);
}
'use strict';

if (window.matchMedia("(max-width: 767px)").matches) {
  $('#sidebar-accordion-footer .plus__icon').show();
  $('#sidebar-accordion-footer').find('li.extend').click(function (e) {
    $(this).children('.extended-submenu').slideToggle('fast');
    $(this).children('.nav__footer--title').children('.plus__icon').toggleClass('opened');
    $(this).toggleClass('active');
  });
}
'use strict';

var pageOverlayOpened = false;
$(".navigation__item--link-megamenu").mouseenter(function () {
  if (pageOverlayOpened == false) {
    $('#page__overlay--navigation').addClass('opened');
    pageOverlayOpened = true;
  }
});

$(".navigation__item--link-megamenu").mouseleave(function () {
  if (pageOverlayOpened == true) {
    $('#page__overlay--navigation').removeClass('opened');
    pageOverlayOpened = false;
  }
});

// Gestion de la hauteur du drawer sur mobile
// a utiliser si le drawer ne fait pas 100% de l'ecran, sinon on peut commenter
if ($(document).scrollTop() > 20) {
  var navbarHeightMobile = 40;
} else {
  var navbarHeightMobile = 74;
}
$('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile); // init
$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    var navbarHeightMobile = 40;
  } else {
    var navbarHeightMobile = 74;
  }
  $('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile);
});
'use strict';

var whiteNavBar = function whiteNavBar() {
  $('#main__logo--svg').removeClass('logo--white');
  $('.link--text-style').removeClass('white');
  $('#icon-account .icon--compte').removeClass('logo--white');
  $('#icon-cart .icon--panier').removeClass('logo--white');
  $('#icon-cart .items--count').removeClass('white');
  $('#icon-search .icon--recherche').removeClass('logo--white');
  $('#icon-underline .icon--soulignement').removeClass('logo--white');
};

var transparentNavbar = function transparentNavbar() {
  $('#main__logo--svg').addClass('logo--white');
  $('.link--text-style').addClass('white');
  $('#icon-account .icon--compte').addClass('logo--white');
  $('#icon-cart .icon--panier').addClass('logo--white');
  $('#icon-cart .items--count').addClass('white');
  $('#icon-search .icon--recherche').addClass('logo--white');
  $('#icon-underline .icon--soulignement').addClass('logo--white');
};

var handleBarChange = function handleBarChange() {
  if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
    $("#navigation--container").addClass('transparent--nav');
    transparentNavbar();
  }
};

if (window.general.headerTransparent == 1) {
  if (window.location.href.indexOf("product") > -1) {
    if (window.matchMedia("(min-width: 1101px)").matches) {

      if ($(document).scrollTop() < 20) {
        if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
          $("#navigation--container").addClass('transparent--nav');
        }
        $('#navigation--container').mouseenter(function () {
          $(this).removeClass('transparent--nav');
        });

        $('#navigation--container').mouseleave(function () {
          if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
            $("#navigation--container").addClass('transparent--nav');
          }
        });
      }

      if ($(document).scrollTop() > 20) {
        $("#navigation--container").removeClass('transparent--nav');
        $("#navigation--container").addClass('scrolled--nav');
      }

      $(document).on('scroll', function () {
        if ($(document).scrollTop() > 20) {
          $("#navigation--container").removeClass('transparent--nav');
          $("#navigation--container").addClass('scrolled--nav');
        } else {
          if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
            $("#navigation--container").addClass('transparent--nav');
          }
          $("#navigation--container").removeClass('scrolled--nav');

          $('#navigation--container').mouseleave(function () {
            if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
              $("#navigation--container").addClass('transparent--nav');
            }
          });
        }
      });
    }
  } else {
    if (window.matchMedia("(min-width: 1101px)").matches) {

      if ($(document).scrollTop() < 20) {
        if ($("#navigation--container").hasClass('fixedWhiteNav') == false) {
          $("#navigation--container").addClass('transparent--nav');
        }
        $('#navigation--container').mouseenter(function () {
          $(this).removeClass('transparent--nav');
          whiteNavBar();
        });

        $('#navigation--container').mouseleave(function () {
          handleBarChange();
        });
      } else {
        $("#navigation--container").removeClass('transparent--nav');
        $("#navigation--container").addClass('scrolled--nav');
        whiteNavBar();
      }

      $(document).on('scroll', function () {
        if ($(document).scrollTop() > 20) {
          $("#navigation--container").removeClass('transparent--nav');
          $("#navigation--container").addClass('scrolled--nav');
          whiteNavBar();

          $('#navigation--container').mouseleave(function () {
            whiteNavBar();
          });
        } else {
          handleBarChange();

          $("#navigation--container").removeClass('scrolled--nav');
          $('#navigation--container').mouseleave(function () {
            handleBarChange();
          });
        }
      });
    }
  }
}

// Gestion de la hauteur du drawer sur mobile
// a utiliser si le drawer ne fait pas 100% de l'ecran
if ($(document).scrollTop() > 20) {
  var navbarHeightMobile = 40;
  $('.image-logo-desktop').css('transform', 'scale(0.90)');
  $('.image-logo-desktop').css('margin-top', '-1px');
} else {
  var navbarHeightMobile = 74;
  $('.image-logo-desktop').css('transform', 'scale(1)');
  $('.image-logo-desktop').css('margin-top', '0px');
}
$('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile); // init
$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    var navbarHeightMobile = 40;
    $('.image-logo-desktop').css('transform', 'scale(0.90)');
    $('.image-logo-desktop').css('margin-top', '-1px');
  } else {
    var navbarHeightMobile = 74;
    $('.image-logo-desktop').css('transform', 'scale(1)');
    $('.image-logo-desktop').css('margin-top', '0px');
  }
  $('#navigation__drawer').css('height', window.innerHeight - navbarHeightMobile);
});

// Gestion du scroll
if (window.matchMedia("(max-width: 1100px)").matches) {
  if ($(document).scrollTop() > 20) {
    $('#navigation__drawer').addClass('scroll-drawer');
  } else {
    $('#navigation__drawer').removeClass('scroll-drawer');
  }
  $(document).on('scroll', function () {
    if ($(document).scrollTop() > 20) {
      $('#navigation__drawer').addClass('scroll-drawer');
    } else {
      $('#navigation__drawer').removeClass('scroll-drawer');
    }
  });
}

var transitionClass;

function transitionMenu() {
  transitionClass = setTimeout(function () {
    $('.sub_sub_link-menu--container').addClass('opacity-div');
  }, 100);
}

if ($('.sub_sub_link-menu--container').hasClass('active')) {
  $('.sub_sub_link-menu--container').removeClass('fade-div');
  $('.sub_sub_link-menu--container.active').addClass('fade-div opacity-div');
}
if ($('.link-menu').hasClass('active')) {
  $('.link-menu').removeClass('color-hover');
  $('.link-menu.active').addClass('color-hover');
}

$('.sub_link-menu--container .sub_link-menu').mouseenter(function () {

  var child = $(this).attr('data-parent');

  $('.link-menu').removeClass('color-hover');
  $(this).children('.link-menu').addClass('color-hover');

  $('.sub_sub_link-menu--container').removeClass('fade-div opacity-div');
  $('.sub_sub_link-menu--container[data-petit-fils="' + child + '"]').addClass('fade-div');
  transitionMenu();
});

$('.megamenu--container').mouseleave(function () {
  if ($('.sub_sub_link-menu--container').hasClass('active')) {
    $('.sub_sub_link-menu--container').removeClass('fade-div opacity-div');
    $('.sub_sub_link-menu--container.active').addClass('fade-div opacity-div');

    $('.link-menu').removeClass('color-hover');
    $('.link-menu.active').addClass('color-hover');
  } else {
    $('.link-menu').removeClass('color-hover');
    $('.sub_link-menu .link-menu.first').addClass('color-hover');
    $('.sub_sub_link-menu--container').removeClass('fade-div opacity-div');
    $('.sub_sub_link-menu--container.first').addClass('fade-div opacity-div');
  }
});

// Survol des categories - Products
$('.one-product, .one-gamme').on('mouseenter', function () {
  $(this).find('.nav__img').hide();
  $(this).find('.nav__img--hover').show();
  var color = $(this).children('.primary__color').attr('hover-color');

  $(this).children('.primary__color').css('color', color);
});

$('.one-product, .one-gamme').on('mouseleave', function () {
  $(this).find('.nav__img').show();
  $(this).find('.nav__img--hover').hide();
  var color = $(this).find('p').attr('color-hover');

  $(this).children('.primary__color').css('color', "#095540");
});
"use strict";

if (window.location.href.indexOf("blog") > -1 || window.location.href.indexOf("article") > -1) {
  $('#icon-search-blog, #icon-search-blog-2').on('click', function () {
    if ($('.search--container').hasClass('opened-blog')) {
      $('.search--container').removeClass('opened-blog');
      $('.searchArticle').val('');
      $(".result-search").html('');
    } else {
      $('.search--container').addClass('opened-blog');
    }
  });

  var handleCloseSearch = function handleCloseSearch() {
    $('.searchArticle').val('');
    $(".result-search").html('');
    $('.search--container').removeClass('opened-blog');
    $('.search--container').css('transform', '');
  };

  $('.close--search').on('click', function () {
    handleCloseSearch();
  });

  $(document).on('click', function (e) {

    var container = $(".search--container");
    var container2 = $(".search--container-barre");
    if ($(e.target).hasClass('search--trigger')) {} else {
      if (container.hasClass('opened-blog') && !container.is(e.target) && container.has(e.target).length === 0) {
        handleCloseSearch();
      }
    }

    if (!container2.is(e.target) && container2.has(e.target).length === 0) {
      $('.searchArticle-barre').val('');
      $('.result-search-barre').html('');
    }
  });
} else {
  var handleSearchBar = function handleSearchBar(searchTriggerId, positionScrolledClass, positionClass, translateYScrolled, translateY) {
    $(searchTriggerId).on('click', function () {
      if ($('.search--container').hasClass(positionScrolledClass) || $('.search--container').hasClass(positionClass)) {
        $('#page__overlay--navigation').removeClass('opened');
        $('.navigation__item--container').removeClass('search--opened');
        $('#navigation--container').removeClass('fixedWhiteNav');
        $('.search--container').removeClass(positionScrolledClass + " " + positionClass);
        $('.search--container').css('transform', '');
        $('.searchProduct').val('');
        $(".result-search").html('');
        $(".popular_product").removeClass('opened');
      } else {
        $('#page__overlay--navigation').addClass('opened');
        $('.navigation__item--container').addClass('search--opened');
        $('#navigation--container').addClass('fixedWhiteNav');
        $('#navigation--container').removeClass('transparent--nav');
        $(".popular_product").addClass('opened');
        if ($(document).scrollTop() >= 20) {
          $('.search--container').addClass(positionScrolledClass);
        } else {
          var topPosition = translateY - $(document).scrollTop();
          $('.search--container').addClass(positionClass);
          $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + topPosition + "px)");
        }
      }
      $('.searchProduct.search--input').focus();
    });

    $(document).on('scroll', function () {
      if ($(document).scrollTop() >= 20) {
        $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + translateYScrolled + "px)");
      } else {
        var topPosition = translateY - $(document).scrollTop();
        $(".search--container." + positionClass + ", .search--container." + positionScrolledClass).css('transform', "translateY(" + topPosition + "px)");
      }
    });
  };

  if (window.matchMedia("(max-width: 767px)").matches) {
    handleSearchBar('#icon-search-mobile', 'opened-mobile-scroll', 'opened-mobile2', 448, 485);
  } else if (window.matchMedia("(max-width: 1200px)").matches) {
    handleSearchBar('#icon-search-mobile', 'opened-mobile-scroll', 'opened-mobile', 448, 488);
  } else {
    handleSearchBar('#icon-search', 'opened-scroll', 'opened', 470, 510);
  }

  var handleCloseSearch = function handleCloseSearch() {
    $('.searchProduct').val('');
    $(".result-search").html('');
    $('.search--container').removeClass('opened opened-scroll opened-mobile-scroll opened-mobile opened-mobile2');
    $('.search--container').css('transform', '');
    $('.popular_product').removeClass('opened');
    $('#navigation--container').removeClass('fixedWhiteNav');
    $('#page__overlay--navigation').removeClass('opened');
    $('.navigation__item--container').removeClass('search--opened');
  };

  $('.close--search').on('click', function () {
    handleCloseSearch();
  });

  $(document).on('click', function (e) {

    var container = $(".search--container");
    if ($(e.target).hasClass('search--trigger')) {} else {
      if ((container.hasClass('opened') || container.hasClass('opened-mobile') || container.hasClass('opened-mobile2') || container.hasClass('opened-scroll') || container.hasClass('opened-mobile-scroll')) && !container.is(e.target) && container.has(e.target).length === 0) {
        handleCloseSearch();
      }
    }
  });

  $(document).on('click', '.global-search', function () {
    //var url = window.location.hostname
    var search = document.getElementsByClassName('searchProduct')[0].value;
    var redirection = "/search?type=product&q=" + search;
    window.location.replace(redirection);
    $('.search--container').removeClass('opened');
  });
}

$(document).on('input', '.search--input', function () {
  if ($(this).attr('search') === 'barre') {
    SearchFunction('searchArticle-barre', 'article', 'result-search-barre');
  } else if ($(this).attr('search') === 'article') {
    SearchFunction('searchArticle', 'article', 'result-search');
  } else if ($(this).attr('search') === 'produit') {
    SearchFunction('searchProduct', 'product', 'result-search');
  }
});

var SearchFunction = function SearchFunction(classInput, typeSearch, classInputResult) {

  var htmlItem = function htmlItem(type, item) {
    console.log('passe article');
    if (type == "article") {
      return "<div class='one-product'><a class='flex fd--row' href=" + item[i].url + "><img class='image-product' src=" + item[i].image + "><div class='content--container flex fd--column'><p class='body--text dark__color text__center'>" + item[i].title + "</p></div></a></div>";
    } else {
      /*if (item[i].compare_at_price_max == 0.00) {
         var prix = item[i].price.replace('.', ',') +'€';
      } else {
        var prix = item[i].price.replace('.', ',') + "€<span class='reduction line__through primary__color'>" + item[i].compare_at_price_max.replace('.', ',') + "€</span>"
      }*/
      var prix = item[i].price.replace('.', ',') + '€';
      var imageResize = item[i].image;
      if (imageResize.includes('.png')) {
        var imageResizeSplit = imageResize.split('.png');
        var imageResizeFinal = imageResizeSplit[0] + '_400x.png';
      } else if (imageResize.includes('.jpg')) {
        var imageResizeSplit = imageResize.split('.jpg');
        var imageResizeFinal = imageResizeSplit[0] + '_400x.jpg';
      } else if (imageResize.includes('.jpeg')) {
        var imageResizeSplit = imageResize.split('.jpeg');
        var imageResizeFinal = imageResizeSplit[0] + '_400x.jpeg';
      }
      return " <div class='one-product product-search'><a class='flex fd--column jc--flex-start' href=" + item[i].url + "><img class='image-product' src=" + imageResizeFinal + "><div class='content--container flex fd--column'><p class='body--text--serif fw--700 primary__color text__center'>" + item[i].title + "</p><p class='price price--tags secondary__color fw--700'>" + prix + "</p></div></a></div>";
    }
  };

  var emptyItem = function emptyItem(type) {
    if (type == "article") {
      return "<div class='empty'>Aucun article ne correspond à votre recherche</div>";
    } else {
      return "<div class='empty'>Aucun produit ne correspond à votre recherche</div>";
    }
  };

  var q = document.getElementsByClassName(classInput)[0].value;
  var b = "&resources[type]=" + typeSearch;
  var c = '';
  if (q == "") {
    $(".result-search").html('');
    $(".result-search-barre").html('');
  }
  if (typeSearch == 'article') {
    var type = "article";
  } else {
    var type = "product";
    c = '&fields=title,product_type,tag';
    if (q == "") {
      $(".popular_product").addClass('opened');
    } else {
      $(".popular_product").removeClass('opened');
    }
  }
  var first;
  if (window.general.langue !== "fr") {
    first = "/" + window.general.langue + "/search/suggest.json?q=";
  } else {
    first = "/search/suggest.json?q=";
  }
  $.ajax(first + q + b + c, {
    type: 'GET',
    dataType: 'json',
    success: function success(response) {
      /*gtag('event', 'search_custom', {
        'label': q
      });*/
      if (window.dataLayer) {
        window.dataLayer.push({
          "event": "genericEvent",
          "eventCategory": "engagement",
          "eventAction": "research",
          "eventLabel": "success",
          "searchTerm": q,
          "searchType": typeSearch
        });
      }

      var itemsSuggestions = response.resources.results[typeSearch + "s"];
      if (itemsSuggestions.length > 0) {
        var result = "";
        for (i = 0; i < itemsSuggestions.length; i++) {
          result += htmlItem(type, itemsSuggestions);
        }
        if (type == "product") {
          result = result + "<div class='global-search'>Plus de résultats</div>";
        }
        $("." + classInputResult).html(result);
      } else {
        var emptyProduct = emptyItem(type);
        $("." + classInputResult).html(emptyProduct);
      }
    }
  });
};
'use strict';

//footer
$(window).on('resize', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('#sidebar-accordion-footer .extended-submenu').hide();
  }
});

// Gestion des boutons
$('.button__with__loading').on('click', function () {
  $(this).children('.button--text').hide();
  $(this).children('.button--loading').css('display', 'flex');
});

// Si go back --> on remet les boutons en mode texte
window.addEventListener("pageshow", function (event) {
  var historyTraversal = event.persisted || typeof window.performance != "undefined" && window.performance.navigation.type === 2;
  if (historyTraversal) {
    $('.button__with__loading').children('.button--text').show();
    $('.button__with__loading').children('.button--loading').css('display', 'none');
  }
});

$('.form--to-validate .form-field').on('invalid', function () {
  $('.form--to-validate .button--text').show();
  $('.form--to-validate .button--loading').css('display', 'none');
});

if (window.matchMedia("(min-width: 768px)").matches) {
  $('body').on('mouseenter', '.test--hover', function () {
    $(this).find('.product__item__div--hover').removeClass('important-none-hover');
    $('.product__item__div--hover-button').css('z-index', '0');
  });
  /*$('.test--hover').mouseenter(function() {
   })*/
  $('body').on('mouseleave', '.test--hover', function () {
    $(this).find('.product__item__div--hover').addClass('important-none-hover');
    $('.product__item__div--hover-button').css('z-index', '100');
  });
}

function deferSrcImages(className) {
  var imgDefer = document.getElementsByClassName(className);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('defer-src')) {
      imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('defer-src'));
    }
  }
}

function deferSrcsetImages(className) {
  var imgDefer = document.getElementsByClassName(className);
  for (var i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('defer-srcset')) {
      imgDefer[i].setAttribute('srcset', imgDefer[i].getAttribute('defer-srcset'));
    }
  }
}

window.onload = function () {
  document.dispatchEvent(new CustomEvent('update-reco-drawer'));
  deferSrcImages("nav__img--hover");
  deferSrcImages("nav__img");
  deferSrcsetImages("source--background");
  setTimeout(function () {
    deferSrcImages("defer--background");
  }, 200);

  deferSrcsetImages("source--product");
  setTimeout(function () {
    deferSrcImages("defer--product");
  }, 200);
};

if (document.readyState == "complete") {
  document.dispatchEvent(new CustomEvent('update-reco-drawer'));
  deferSrcImages("nav__img--hover");
  deferSrcImages("nav__img");
  deferSrcsetImages("source--background");
  setTimeout(function () {
    deferSrcImages("defer--background");
  }, 200);

  deferSrcsetImages("source--product");
  setTimeout(function () {
    deferSrcImages("defer--product");
  }, 200);
}

$('.estimer-frais').on('click', function () {
  deferSrcImages("logo--shipping");
});

//sticky product article mobile
if (window.matchMedia("(max-width: 767px)").matches) {
  if ($(document).scrollTop() > 200) {
    $('.product-reco-mobile--article').addClass('visible');
  } else {
    $('.product-reco-mobile--article').removeClass('visible');
  }

  $(document).on('scroll', function () {
    if ($(document).scrollTop() > 200) {
      $('.product-reco-mobile--article').addClass('visible');
    } else {
      $('.product-reco-mobile--article').removeClass('visible');
    }
  });
}
if (window.matchMedia("(max-height: 700px)").matches) {
  $('.second-article-sticky').hide();
}

$('.diagnostic-button').on('click', function () {
  gtag('event', 'diagnostic', {
    'label': 'Commencer'
  });
});

$('.wisp').on('click', function () {
  gtag('event', 'wisp', {
    'label': 'Click'
  });
});

$('body').on('click', '.product-search', function () {
  var title = $(this).find('.body--text--serif').text();
  gtag('event', 'product_search', {
    'label': title
  });
});

// Liste des jours fériés sous forme de chaînes de caractères au format 'MM-DD'
var fixedHolidays = ['01-01', // Jour de l'An
'05-01', // Fête du Travail
'05-08', // Victoire des Alliés 1945
'07-14', // Fête Nationale
'08-15', // Assomption
'11-01', // Toussaint
'11-11', // Armistice 1918
'12-25'];

// Note : Pour les jours fériés mobiles comme Pâques, l'Ascension, et la Pentecôte,
// vous auriez besoin d'une logique supplémentaire pour calculer leurs dates.

function isHoliday(date) {
  var monthDay = date.toISOString().slice(5, 10);
  return fixedHolidays.includes(monthDay);
}

function addBusinessDays(date, daysToAdd) {
  var newDate = new Date(date);
  var businessDaysLeft = daysToAdd;
  var dayOfWeek = void 0;

  while (businessDaysLeft > 0) {
    newDate.setDate(newDate.getDate() + 1); // Augmente la date d'un jour
    dayOfWeek = newDate.getDay();

    // Si ce n'est pas un week-end et pas un jour férié, décrémente le compteur de jours ouvrés
    if (dayOfWeek !== 0 && dayOfWeek !== 6 && !isHoliday(newDate)) {
      businessDaysLeft--;
    }
  }

  return newDate;
}

// Utilisation :
var orderDate = new Date(); // Date actuelle
var deliveryDate = addBusinessDays(orderDate, 3);

// Affiche la date de livraison :
//console.log(deliveryDate.toLocaleDateString());
$('.js-jours').text(deliveryDate.toLocaleDateString());

$('.click-market').on('click', function () {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $(this).find('.icon-arrow-switcher').removeClass('opened');
    $('.dropdown-markets').addClass('display__none');
  } else {
    $(this).addClass('active');
    $(this).find('.icon-arrow-switcher').addClass('opened');
    $('.dropdown-markets').removeClass('display__none');
  }
});
'use strict';

$('#go-top').on('click', function () {
  $('html, body').animate({
    scrollTop: 0
  }, 500);
});

if ($(document).scrollTop() > 20) {
  $('#go-top').show();
} else {
  $('#go-top').hide();
}

$(document).on('scroll', function () {
  if ($(document).scrollTop() > 20) {
    $('#go-top').show();
  } else {
    $('#go-top').hide();
  }
});
'use strict';

var displayPrice = function displayPrice(price) {
  return price / 100 + '€';
};
'use strict';

$('#newsletter--homepage, #newsletter--footer').submit(function (e) {
  e.preventDefault();
  var index = $(this).attr('form-index');
  var email = $('.email--newsletter[form-index="' + index + '"]').val().toLowerCase();
  var fields = "$source,$email,$consent";
  var formData = {
    "email": email,
    "g": $('.list--newsletter[form-index="' + index + '"]').val(),
    "$consent": "email",
    "$source": $('.newsletter-form[form-index="' + index + '"]').attr('source'),
    "$fields": fields
  };

  window.dataLayer.push({
    "event": "genericEvent",
    "eventCategory": "engagement",
    "eventAction": "newsletter",
    "eventLabel": "success"
  });

  $.ajax({
    type: "POST",
    url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
    data: formData,
    dataType: 'json',
    success: function success(response) {

      if (response.errors && response.errors.length > 0) {
        $('.newsletter-form .error--email').show();
        _learnq.push(['identify', {
          '$email': email
        }]);
      } else {
        $('.newsletter-form .success--email').show();
      }
    },
    error: function error(_error) {
      $('.newsletter-form .error--email').show();
    }
  });
});
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LocalizationForm = function (_HTMLElement) {
  _inherits(LocalizationForm, _HTMLElement);

  function LocalizationForm() {
    _classCallCheck(this, LocalizationForm);

    var _this = _possibleConstructorReturn(this, (LocalizationForm.__proto__ || Object.getPrototypeOf(LocalizationForm)).call(this));

    _this.elements = {
      input: _this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: _this.querySelector("button"),
      panel: _this.querySelector(".disclosure__list")
    };
    _this.elements.button.addEventListener("click", _this.openSelector.bind(_this));
    _this.elements.button.addEventListener("focusout", _this.closeSelector.bind(_this));
    _this.addEventListener("keyup", _this.onContainerKeyUp.bind(_this));

    _this.querySelectorAll("a").forEach(function (item) {
      return item.addEventListener("click", _this.onItemClick.bind(_this));
    });
    return _this;
  }

  _createClass(LocalizationForm, [{
    key: "hidePanel",
    value: function hidePanel() {
      this.elements.button.setAttribute("aria-expanded", "false");
      this.elements.panel.setAttribute("hidden", true);
    }
  }, {
    key: "onContainerKeyUp",
    value: function onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") {
        return;
      }

      this.hidePanel();
      this.elements.button.focus();
    }
  }, {
    key: "onItemClick",
    value: function onItemClick(event) {
      event.preventDefault();
      var form = this.querySelector("form");
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) {
        form.submit();
      }
    }
  }, {
    key: "openSelector",
    value: function openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute("hidden");
      this.elements.button.setAttribute("aria-expanded", (this.elements.button.getAttribute("aria-expanded") === "false").toString());
    }
  }, {
    key: "closeSelector",
    value: function closeSelector(event) {
      var shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }]);

  return LocalizationForm;
}(HTMLElement);

customElements.define("localization-form", LocalizationForm);
'use strict';

$('.faq__q__and__a').on('click', function () {
  $('.arrow-bottom').attr('arrow-open', 'false');
  var $question = $(this).children('.faq__question');
  $('.plus__icon').removeClass('opened');
  $question.children('.plus__icon').toggleClass('opened');
  if ($question.next().attr('aria-hidden') == 'false') {
    $question.next().slideToggle(200).attr('aria-hidden', 'true');
    $(this).find('span').attr('arrow-open', 'false');
    $('.plus__icon').removeClass('opened');
  } else {
    $('.faq__q__and__a').find('.faq__answer[aria-hidden="false"]').not($question).slideToggle(200).attr('aria-hidden', 'true');
    $question.next().slideToggle(200).attr('aria-hidden', 'false');
    $(this).find('span').attr('arrow-open', 'true');
  }
});

$('.question').on('click', function () {
  $('.arrow-bottom').attr('arrow-open', 'false');
  if ($(this).next().attr('aria-hidden') == 'false') {
    $(this).next().slideToggle(200).attr('aria-hidden', 'true');
    $(this).find('span').attr('arrow-open', 'false');
  } else {
    $('.faq--container').find('.faq__answer[aria-hidden="false"]').not(this).slideToggle(200).attr('aria-hidden', 'true');
    $(this).next().slideToggle(200).attr('aria-hidden', 'false');
    $(this).find('span').attr('arrow-open', 'true');
  }
});

$('.picto__container').on('click', function () {
  var number = $(this).attr('data-separator');
  $('.picto__container').removeClass('is-active');
  $(this).addClass('is-active');
  $('.questions__container.is-opened').removeClass('is-opened is-visible');
  $('.questions__container[data-separator=' + number + ']').addClass('is-opened');
  setTimeout(function () {
    $('.questions__container[data-separator=' + number + ']').addClass('is-visible');
  }, 10);
});
'use strict';

$('.letter__link').on('click', function () {
  var id = $(this).attr('href');
  $('.letter__link.active').removeClass('active');
  $(this).addClass('active');
  $('html, body').animate({
    scrollTop: $(id).offset().top - 160
  }, 500);
});

$('.filter__button_herbiers').on('click', function () {
  var selectedFilter = this.value;
  var id;
  $('.container__ingredient').each(function (i, item) {
    if ($(item).attr("tags__filter").includes(selectedFilter)) {
      $(item).show();
      // Changer l'id pour l'ancre avec les lettres
      $(item).attr("id", $(item).attr("value"));
    } else {
      $(item).attr("id", "");
      $(item).hide();
    }
  });
});

$('.filter__button_herbiers').on('click', function () {
  $('.icon--arrow-bottom').removeClass('opened');
  if ($('.filter__group--title').hasClass('opened')) {
    // Ferme l'accordeon
    $('.filter__group--title').removeClass('opened');
    $('.filter__group--title').children('.filter__section--title').children('.icon--arrow-bottom').removeClass('opened');

    if (window.matchMedia("(max-width: 767px)").matches) {
      $('.filter__group--title').siblings('.filter__group--item-list').slideUp(300);
    }
  } else {
    // Ouvre l'accordeon
    $('.filter__group--title').children('.filter__section--title').children('.icon--arrow-bottom').toggleClass('opened');
    $('.filter__group--title').siblings('.filter__group--item-list').slideToggle(300);
    $('.filter__group--title').removeClass('opened');
    $('.filter__group--title').toggleClass('opened');
  }
});

$('body').on('click', '.filter__button_herbiers', function () {
  // Gestion de l'accordeon
  $("#filter_selected").text(this.value);
  if (window.matchMedia("(min-width: 768px)").matches) {
    $('.filter__group--item-list').slideUp(300);
    $('.icon--arrow-bottom').removeClass('opened');
  }
  $('.filter__group--title').removeClass('opened');
  $('.filter__values--list').show();
});

$('body').on('click', '.close__filter', function () {
  $('.container__ingredient').each(function (i, item) {
    $(item).show();
    $(item).attr("id", $(item).attr("value"));
  });
  $('.filter__value--ingredients').hide();
});
'use strict';

$('#close-article-page').on('click touchend', function () {
  $('#article-page-overlay').hide();
});
$(document).mouseup(function (e) {
  var container = $("#article-page");
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('#article-page-overlay').hide();
  }
});
$('.article').on('click touchend', function () {
  var background_url = "https:" + $(this).attr('background-img');
  $('#click-contain img').attr('src', background_url);
  $('#article-page-overlay').show().css('display', 'flex');
});
'use strict';

var compteurSlider = 0;
$(document).on('click', '.link__slider', function (event) {
  var block_slider = $(this).attr('block-number');
  $(".link__slider.link__active-home").removeClass('link__active-home');
  $(".slider--container").hide();
  $(this).addClass('link__active-home');
  $(".slider--container[block-number='" + block_slider + "']").show();

  if (compteurSlider == 0) {
    if (block_slider == "2") {
      compteurSlider += 1;

      $('#swiper-container-featured-collection-2').slick({
        dots: false,
        infinite: true,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        }]
      });
    }
  }
});
'use strict';

var compteur = 0;
$('.one-block').on('click', function () {
  var option = $(this).attr('popup');

  $('#' + option).css("display", "flex");
  if (option == "popup-1") {
    compteur = 1;
    if (compteur == 1) {
      setTimeout(function () {
        $('.infos-slider-ingredients').slick({
          dots: true,
          customPaging: function customPaging(slider, i) {
            return '<button class="tab"></button>';
          },
          infinite: true,
          asNavFor: '.image-slider-ingredients',
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        });

        $('.image-slider-ingredients').slick({
          dots: false,
          infinite: true,
          asNavFor: '.infos-slider-ingredients',
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          variableWidth: true
        });
      }, 100);
    }
  }
});

$('.close-popup').on('click', function () {
  $('.popup--container').css("display", "none");
});

$('.see-more-faq').click(function () {
  $('#height--container').css("max-height", '1000px');
  $(this).hide();
});
'use strict';

$('ul.sidebar-accordion').find('li.extend').click(function () {
  $('li.extend.active').not($(this)).toggleClass('active');
  //Expand or collapse this panel
  $(this).next().slideToggle('fast');
  $(this).toggleClass('active');
  //Hide the other panels
  $("ul.extended-submenu").not($(this).next()).slideUp('fast');
});

$('#moreDetails').on('click', function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    $('html, body').animate({
      scrollTop: $(".ProductDescription--mobile-container").offset().top - 140
    }, 600);
  } else {
    $('html, body').animate({
      scrollTop: $(".ProductDescription").offset().top - 200
    }, 600);
  }
});

$('.tabs').each(function () {
  var active,
      content,
      links = $(this).find('a');
  active = links.first().addClass('active');
  content = $(active.attr('href'));
  links.not(':first').each(function () {
    $($(this).attr('href')).hide();
  });
  $(this).find('a').click(function (e) {
    active.removeClass('active');
    content.hide();
    active = $(this);
    content = $($(this).attr('href'));
    active.addClass('active');
    content.show();
    return false;
  });
});

$('#details__anchor').on('click', function () {
  var id = $(this).attr('href');

  $('html, body').animate({
    scrollTop: $(id).offset().top - 150
  }, 500);
});
'use strict';

$('#slider--product').slick({
  dots: false,
  infinite: false,
  arrows: false,
  waitForAnimate: false,
  responsive: [{
    breakpoint: 767,
    settings: {
      dots: true,
      customPaging: function customPaging(slider, i) {
        return '<button class="tab"></button>';
      }
    }
  }]
});

// Zoom on carousell hover gallerys
if (typeof zoom === "function" || window.location.pathname.indexOf('products') > -1) {
  if (window.matchMedia("(min-width: 768px)").matches) {
    $('.product-zoom').zoom({ on: 'click' });
  }
}

$('#slider--product').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  $('#slider__nav--product .carousel-cell').removeClass('is-nav-selected');
  $('#slider__nav--product .carousel-cell[thumb-index="' + nextSlide + '"]').addClass('is-nav-selected');
});

$('#slider__nav--product .carousel-cell').on('click', function () {
  var index = $(this).attr('thumb-index');
  $('#slider__nav--product .carousel-cell').removeClass('is-nav-selected');
  $(this).addClass('is-nav-selected');
  $('#slider--product').slick('slickGoTo', index);
});
'use strict';

var productDetails = {};
if ($('[product-details]').html()) {
  productDetails = JSON.parse($('[product-details]').html());
}

$('.quantity__change--selector-product').on('click', function () {
  var type = $(this).attr('type');
  var currentQty = parseInt($('.product__qty--container .quantity__current').val());

  if (type == 'minus') {
    if (currentQty != 0) {
      $('.product__qty--container .quantity__current').val(currentQty - 1);
    }
  } else {
    $('.product__qty--container .quantity__current').val(currentQty + 1);
  }
});

document.addEventListener('select-changed:product__option--1', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);
document.addEventListener('select-changed:product__option--2', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);
document.addEventListener('select-changed:product__option--3', function (event) {
  if (event.detail.quickAdd == "true") {
    onOptionChangedQuickAdd();
  } else {
    onOptionChanged();
  }
}, false);

// Change variant for bulles
$('.bulle__custom--value').on('click', function () {
  var value = $(this).text();
  var option = $(this).attr('for');

  $('.select__custom--selected-value[for="' + option + '"]').text(value);
  $('.bulle__custom--value[for="' + option + '"]').removeClass('is__active');
  $(this).addClass('is__active');

  document.dispatchEvent(new CustomEvent('select-changed:' + option, { 'detail': { quickAdd: "false" } }));
});

function updateProductButton(variant, productId) {
  console.log(variant);
  var price = parseFloat(variant.price.replace('€', ''));
  var compareAtPrice = parseFloat(variant.compareAtPrice.replace('€', ''));
  if (variant.available == 0) {
    $('.add__to__cart[product-id="' + productId + '"]').html('' + window.translate.outOfStock);
    $('.add__to__cart[product-id="' + productId + '"]').attr('id', 'BIS_trigger');
    $('.add__to__cart[product-id="' + productId + '"]').attr('variant-available', false);
    $('.add__to__cart[product-id="' + productId + '"]').attr('data-variant-id', variant.id);
    $('.add__to__cart[product-id="' + productId + '"]').attr('type', 'button');
  } else {
    $('.add__to__cart[product-id="' + productId + '"]').attr('id', 'button--add-cart');
    $('.add__to__cart[product-id="' + productId + '"]').attr('variant-available', true);
    $('.add__to__cart[product-id="' + productId + '"]').attr('data-variant-id', variant.id);
    $('.add__to__cart[product-id="' + productId + '"]').attr('type', 'submit');
    if (compareAtPrice > price) {
      $('.add__to__cart[product-id="' + productId + '"]').html('' + window.translate.addToCart);
    } else {
      $('.add__to__cart[product-id="' + productId + '"]').html('' + window.translate.addToCart);
    }
  }
}

function onOptionChanged() {
  var productOptions = [];

  for (var i = 1; i <= 3; i++) {
    productOptions[i - 1] = $('.select__custom--selected-value[product-id="' + productDetails.productId + '"][name="product__option--' + i + '"]').text().trim() || "";
  }
  if (productDetails && productDetails.variants.length > 1) {
    productDetails.variants.forEach(function (variant) {
      if (variant.option1 == productOptions[0] && variant.option2 == productOptions[1] && variant.option3 == productOptions[2]) {
        $('.product--price').text(variant.price);
        $('.add__to__cart[product-id="' + productDetails.productId + '"]').attr('variant-price', variant.price.replace("€", "").replace(",", "."));

        if (variant.price == variant.compareAtPrice) {
          $('.product--compare-at-price').hide();
        } else {
          $('.product--compare-at-price').show();
        }

        $('.product--compare-at-price').text(variant.compareAtPrice);
        $('.add__to__cart[product-id="' + productDetails.productId + '"]').attr('variant-id', variant.id);
        var url = document.location.origin + document.location.pathname + ('?variant=' + variant.id);
        window.history.replaceState({ path: url }, '', url);
        var featuredImage = variant.imageId;

        // Change image on variant change
        var imageNumber = parseInt($('#slider--product .product__image[image-id="' + featuredImage + '"]').attr("slide-number")) - 1;
        if (imageNumber) {
          $('#slider--product').slick('slickGoTo', imageNumber);
        }

        updateProductButton(variant, productDetails.productId);
      }
    });
  }
}

var navigationDesProduct = undefined;
function initNavigationDesProduct() {
  if (window.matchMedia("(max-width: 767px)").matches && navigationDesProduct == undefined) {
    $('.sidebar-accordion-description-product .plus__icon').show();
    $('.sidebar-accordion-description-product').find('li.extend').click(function (e) {
      $(this).children('.extended-submenu').slideToggle('fast');
      $(this).children('.nav__des-product--title').children('.plus__icon').toggleClass('opened');
      $(this).children('.nav__des-product--title').children('.body__text--navigation').toggleClass('primary__color--medium').toggleClass('dark__color');
      $(this).toggleClass('active');
    });
    navigationDesProduct = 1;
  } else if (window.matchMedia("(min-width: 768px)").matches && navigationDesProduct != undefined) {
    $('.sidebar-accordion-description-product').find('li.extend').off('click');
    $('.sidebar-accordion-description-product .extended-submenu').hide();
    $('.sidebar-accordion-description-product .plus__icon').hide().removeClass('opened');
    navigationDesProduct = undefined;
  }
}
initNavigationDesProduct();

$(window).on('resize', function () {
  initNavigationDesProduct();
});

// Sticky Add To Cart
/*if (window.matchMedia("(min-width: 1100px)").matches) {*/
var scrollHeight = $('#slider--product').height() - 200;
if ($(document).scrollTop() > scrollHeight) {
  $('#add-to-cart--sticky').css('visibility', 'visible');
  setTimeout(function () {
    $('#add-to-cart--sticky').addClass('visible');
  }, 20);
} else {
  $('#add-to-cart--sticky').removeClass('visible');
  setTimeout(function () {
    $('#add-to-cart--sticky').css('visibility', 'hidden');
  }, 410);
}

$(document).on('scroll', function () {
  if ($(document).scrollTop() > scrollHeight) {
    $('#add-to-cart--sticky').css('visibility', 'visible');
    setTimeout(function () {
      $('#add-to-cart--sticky').addClass('visible');
    }, 20);
  } else {
    $('#add-to-cart--sticky').removeClass('visible');
    setTimeout(function () {
      $('#add-to-cart--sticky').css('visibility', 'hidden');
    }, 410);
  }
});
/*
}*/

$('body').on('click', '.know-more-product', function () {
  var id = $(this).attr('href');
  $('html, body').animate({
    scrollTop: $(id).offset().top - 170
  }, 500);
});

$('body').on('click', '.select__custom--lot', function () {
  var forSelect = $(this).attr('for');
  var value = $(this).attr('value');

  if ($('.lot-select-banner--container').hasClass('opened')) {
    $('.lot-select-banner--container').removeClass('opened');
    $('.lot-product-banner--container').css('display', 'none');
    $('.lot-select-banner--container').children('.icon--arrow-bottom').removeClass('opened');
  }

  $('.select__custom--lot[for="' + forSelect + '"]').removeClass('is__active');
  $('.select__custom--lot[value="' + value + '"]').addClass('is__active');
  //$(this).addClass('is__active');
  $('.select__custom--selected-value[name="' + forSelect + '"]').text(value);
  $('.select__custom--selected-value-banner[name="' + forSelect + '"]').text(value);

  var productOptions = [];
  for (var i = 1; i <= 3; i++) {
    productOptions[i - 1] = $('.select__custom--selected-value[product-id="' + productDetails.productId + '"][name="product__option--' + i + '"]').text().trim() || "";
  }
  if (productDetails && productDetails.variants.length > 1) {
    productDetails.variants.forEach(function (variant) {
      if (variant.option1 == productOptions[0] && variant.option2 == productOptions[1] && variant.option3 == productOptions[2]) {
        $('.product--price').text(variant.price);
        if (variant.price == variant.compareAtPrice) {
          $('.product--compare-at-price').hide();
        } else {
          $('.product--compare-at-price').show();
        }
        $('.product--compare-at-price').text(variant.compareAtPrice);
        $('.add__to__cart[product-id="' + productDetails.productId + '"]').attr('variant-id', variant.id);
        var url = document.location.origin + document.location.pathname + ('?variant=' + variant.id);
        window.history.replaceState({ path: url }, '', url);
        var featuredImage = variant.imageId;

        console.log(featuredImage);
        // Change image on variant change
        var imageNumber = parseInt($('#slider--product .product__image[image-id="' + featuredImage + '"]').attr("slide-number")) - 1;
        console.log(imageNumber);
        if (imageNumber) {
          $('#slider--product').slick('slickGoTo', imageNumber);
        } else if (imageNumber == 0) {
          $('#slider--product').slick('slickGoTo', imageNumber);
        }

        updateProductButton(variant, productDetails.productId);
      }
    });
  }
});

$('body').on('click', '.lot-select-banner--container', function () {
  if ($(this).hasClass('opened')) {
    $(this).removeClass('opened');
    $('.lot-product-banner--container').css('display', 'none');
    $(this).children('.icon--arrow-bottom').removeClass('opened');
  } else {
    $(this).addClass('opened');
    $('.lot-product-banner--container').css('display', 'grid');
    $(this).children('.icon--arrow-bottom').addClass('opened');
  }
});

/*$(window).on('load', function(){
  if (window.location.href.indexOf("product") > -1){
    $(".select__custom--lot[value='3 mois']").click()
  }
})*/
});